// Central place for build-time config derived from Vite env vars.

const trimTrailingSlash = (s: string) => s.replace(/\/+$/, "");

export const API_BASE_URL = trimTrailingSlash(import.meta.env.VITE_API_BASE_URL || "/v1");

// WS base host (scheme + host, no path). Defaults to the current origin with the
// ws/wss scheme so local dev works through the Vite proxy.
export const WS_BASE_URL = (() => {
  const configured = import.meta.env.VITE_WS_BASE_URL;
  if (configured) return trimTrailingSlash(configured);
  if (typeof window !== "undefined") {
    const scheme = window.location.protocol === "https:" ? "wss" : "ws";
    return `${scheme}://${window.location.host}`;
  }
  return "ws://localhost:8080";
})();

export const REQUIRE_AUTH = (import.meta.env.VITE_STUDIO_REQUIRE_AUTH || "false") === "true";

// Self-hosted Phoenix (LLM traces) for this environment. When set, the call
// drawer links to the call's trace and its conversation.
export const PHOENIX_URL = trimTrailingSlash(import.meta.env.VITE_PHOENIX_URL || "");

export const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "",
};

// Firebase auth is only usable when a web config is present.
export const FIREBASE_ENABLED = Boolean(firebaseConfig.apiKey && firebaseConfig.projectId);

// The course catalog lives in a SECOND Firebase project (aura-courses), shared
// by the mobile app, the backend's onboarding seeds and the aura-course-rag
// Functions. Studio opens it as a named Firebase app (config/firebase.ts).
export const coursesFirebaseConfig = {
  apiKey: import.meta.env.VITE_COURSES_FIREBASE_API_KEY || "",
  authDomain: import.meta.env.VITE_COURSES_FIREBASE_AUTH_DOMAIN || "",
  projectId: import.meta.env.VITE_COURSES_FIREBASE_PROJECT_ID || "",
  storageBucket: import.meta.env.VITE_COURSES_FIREBASE_STORAGE_BUCKET || "",
  appId: import.meta.env.VITE_COURSES_FIREBASE_APP_ID || "",
};

// Without the courses web config the sidebar entry stays "coming soon" and no
// courses code touches Firebase, so a build without these vars is unchanged.
export const COURSES_ENABLED = Boolean(coursesFirebaseConfig.apiKey && coursesFirebaseConfig.projectId);

// One aura-courses project serves every environment, so a non-prod Studio
// build edits the same live catalog as prod. The Courses pages say so.
export const IS_PROD_BUILD = import.meta.env.MODE === "prod";
